import script from "./AdventureChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChat.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChat.vue?vue&type=style&index=0&id=2300360f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2300360f"]])

export default __exports__